import { render, staticRenderFns } from "./ButtonWithIcon.vue?vue&type=template&id=2e7a6a19&scoped=true&"
import script from "./ButtonWithIcon.vue?vue&type=script&lang=ts&"
export * from "./ButtonWithIcon.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonWithIcon.vue?vue&type=style&index=0&id=2e7a6a19&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7a6a19",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
